export default __webpack_public_path__ + "static/media/mt4.089bb556.png";